import { render, staticRenderFns } from "./SelectIt.vue?vue&type=template&id=0b71daca&scoped=true&"
import script from "./SelectIt.vue?vue&type=script&lang=ts&"
export * from "./SelectIt.vue?vue&type=script&lang=ts&"
import style0 from "./SelectIt.vue?vue&type=style&index=0&id=0b71daca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b71daca",
  null
  
)

export default component.exports